var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"writer-wrap"},[_c('textarea',{attrs:{"name":_vm.name,"id":'editor' + _vm.id},domProps:{"innerHTML":_vm._s(_vm.precontent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }